function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Pagina\xE7\xE3o");

var SvgPagination = function SvgPagination(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M7,42.71v8.58a2,2,0,0,0,2.1,2H86.89a2,2,0,0,0,2.1-2V42.71ZM22.89,49.2a1,1,0,0,1-1.06,1H11.14a1,1,0,0,1-1.06-1V46.8a1,1,0,0,1,1.06-1H21.83a1,1,0,0,1,1.06,1Zm39,.4a.63.63,0,0,1-.64.61H57.91a.62.62,0,0,1-.63-.61.63.63,0,0,1-.64.61H53.27a.62.62,0,0,1-.63-.61.62.62,0,0,1-.64.61H48.63A.62.62,0,0,1,48,49.6a.62.62,0,0,1-.63.61H44a.62.62,0,0,1-.64-.61V46.4a.62.62,0,0,1,.64-.61h3.37a.62.62,0,0,1,.63.61.62.62,0,0,1,.63-.61H52a.62.62,0,0,1,.64.61.62.62,0,0,1,.63-.61h3.37a.63.63,0,0,1,.64.61.62.62,0,0,1,.63-.61h3.37a.63.63,0,0,1,.64.61Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPagination, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PAGINATION.8c6d10fe.svg";
export { ForwardRef as ReactComponent };